'use client';

import React from 'react';
import { Breadcrumbs } from '@benzinga/core-ui';
import { ShareButtons } from '@benzinga/ui';
import type { Breadcrumb } from '@benzinga/content-manager';
import { LayoutPageHeader } from '../../../../_components/LayoutPageHeader/LayoutPageHeader';

export interface OptionsProfitHubChromeProps {
  breadcrumbs: Breadcrumb[];
  buttonLocation?: string;
  canonical: string;
  children: React.ReactNode;
  description: string;
  shareTitle: string;
  title: string;
}

export function OptionsProfitHubChrome({
  breadcrumbs,
  buttonLocation = 'options_calculator_page',
  canonical,
  children,
  description,
  shareTitle,
  title,
}: OptionsProfitHubChromeProps) {
  const shareButtons = (
    <div className="header-actions">
      <div className="flex flex-row flex-wrap items-center gap-2">
        <ShareButtons
          buttonLocation={buttonLocation}
          showButtons={['linkedin', 'twitter', 'facebook', 'bluesky']}
          title={shareTitle}
          url={canonical}
          buttonStyle={{ borderRadius: 4 as number }}
        />
        <ShareButtons
          buttonLocation={buttonLocation}
          showButtons={['email', 'copy']}
          title={shareTitle}
          url={canonical}
          buttonStyle={{
            borderRadius: 4 as number,
            bgStyle: { fill: '#17315d' } as React.CSSProperties,
            iconFillColor: '#3F83F8',
          }}
        />
      </div>
    </div>
  );

  return (
    <>
      <LayoutPageHeader className="relative z-10 w-full overflow-hidden text-white">
        <Breadcrumbs
          className="calendar-header-crumbs layout-page-header__crumbs--tools"
          data={breadcrumbs}
          separator="/"
          showEdgeBadge={false}
        />
        <div className="new-layout-header-wrapper">
          <div className="header-content max-w-2xl min-w-0">
            <h1 className="header-title text-white">{title}</h1>
            <p className="header-description">{description}</p>
          </div>
        </div>
        <div className="calendar-header-share-buttons-wrapper">{shareButtons}</div>
      </LayoutPageHeader>
      <div className="min-h-[40vh] border-t border-bzblue-400 bg-bzblue-200">
        <div className="mx-auto max-w-[1400px] px-4 pb-4 pt-6 md:px-6 md:pb-5 md:pt-8">{children}</div>
      </div>
    </>
  );
}
